import { useMemo } from "react";
import { Stack, TablePagination } from "@mui/material";
import { LegendComponent } from "../../../../../../common/components/legend_component";
import { LegendIcon } from "../../../../../../common/components/legend_icon";
import { LegendItemComponent } from "../../../../../../common/components/legend_item_component";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GenerateHabilidadeColumnsDefinition } from "../columns";
import { AvaliacaoHabilidade } from "../../../../domain/models/avaliacao_habilidade";

import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * TabHabilidadesContent
 */

type Props = {
  loading: boolean,
  habilidadesPage: number,
  habilidadesRowsPerPage: number,
  habilidadesTotalItems: number,
  habilidadesLista: AvaliacaoHabilidade[],
  onHabilidadesPageChange: (page: number) => void,
  onHabilidadesRowsPerPageChange: (rowsPerPage: number) => void,
  onCadastrarHabilidade: (idHabilidade: number | null, open: boolean) => void,
  onExportar: (idTreinamento: number | null) => void,
  onEditar: (idTreinamento: number | null, open: boolean) => void,
  onDeletar: (idTreinamento: number | null, open: boolean) => void,
};

export const TabHabilidadesContent = ({
  loading,
  habilidadesPage,
  habilidadesRowsPerPage,
  habilidadesTotalItems,
  habilidadesLista,
  onHabilidadesPageChange,
  onHabilidadesRowsPerPageChange,
  onCadastrarHabilidade,
  onExportar,
  onEditar,
  onDeletar,
}: Props) => {
  const habilidadeColumnsDefinition = useMemo(() => {
    return GenerateHabilidadeColumnsDefinition({
      onExportar: (id) => onExportar(id),
      onEditar: (id) => onEditar(id, true),
      onDeletar: (id) => onDeletar(id, true),
    });
  }, [
    onExportar,
    onEditar,
    onDeletar,
  ]);

  return (
    <>
      <>
        <div className="div flex mt-8 justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-xl font-medium text-black dark:text-white">
              Habilidades
            </h1>
          </div>

          <div className="flex justify-end gap-2">
            <PrimaryButton
              className="whitespace-nowrap"
              sx={{ paddingX: 3 }}
              onClick={() => onCadastrarHabilidade(null, true)}>
              Cadastrar Habilidade
            </PrimaryButton>
          </div>
        </div>
      </>

      <Stack spacing={0} className="mt-4">
        <div className="w-full flex flex-row justify-between items-end my-4">
          <LegendComponent>
            <LegendItemComponent
              icon={<LegendIcon color='green' title='C' />}
              label='Avaliação concluída' />

            <LegendItemComponent
              icon={<LegendIcon color='yellow' title='D' />}
              label='Avalição dentro do prazo' />

            <LegendItemComponent
              icon={<LegendIcon color='red' title='A' />}
              label='Avalição atrasada' />

          </LegendComponent>

          <div className="shrink-0 grow-0 basis-auto">
            <TablePagination
              component="div"
              count={habilidadesTotalItems}
              page={habilidadesPage - 1}
              onPageChange={(_, p) => onHabilidadesPageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={habilidadesRowsPerPage}
              onRowsPerPageChange={(e) => onHabilidadesRowsPerPageChange(parseInt(e.target.value))} />
          </div>
        </div>

        <StyledDataGrid
          tableName="tab_habilidades_content"
          disableColumnMenu={false}
          disableRowSelectionOnClick={true}
          getRowId={(row: AvaliacaoHabilidade) => row.idAvaliacaoHabilidade}
          columns={habilidadeColumnsDefinition}
          loading={loading}
          rows={habilidadesLista}
          rowCount={habilidadesLista.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: habilidadesPage,
            pageSize: habilidadesRowsPerPage,
          }} />

        <TablePagination
          component="div"
          count={habilidadesTotalItems}
          page={habilidadesPage - 1}
          onPageChange={(_, p) => onHabilidadesPageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={habilidadesRowsPerPage}
          onRowsPerPageChange={(e) => onHabilidadesRowsPerPageChange(parseInt(e.target.value))} />

      </Stack>
    </>
  );
}